module.exports = __webpack_public_path__ + "assets/img/c2.971cbd05.png";